<div class="hide-element" role="heading" aria-level="1">Account Portal</div>
<router-outlet *ngIf="displayApp$ | async"></router-outlet>
<div id="ap--version-id" class="display--none" aria-hidden="true">Version: {{ version }}</div>
<ng-container *ngIf="notifications$ | async as notification">
	<ahp-notification *ngIf="notification.current" [notify]="notification.current"></ahp-notification>
</ng-container>
